<template>
    <Fold
        class="newsletter-fold"
        @click="loadAnsShowPopup"
    >
        Castorama newsletter - zapisz się
    </Fold>
</template>

<script>
import Fold from '~/components/common/Fold';

export default {
    name: 'NewsletterFold',
    components: {
        Fold,
    },
    methods: {
        async loadAnsShowPopup(event) {
            if (event) {
                event.preventDefault();
                const { default: instance } = await import('~/components/common/Popup/NewsletterPopup' /* webpackChunkName: "popup/newsletter" */);
                this.$popup.set({
                    instance,
                    optionalProps: {
                        action: 'Zapis - stopka',
                        styleButton: 'modal__close--white',
                    },
                });
            }
        },
    },
};
</script>

<style lang="scss">
    .newsletter-fold {
        background: url('~static/images/svg/newsletter-fold.svg') top left no-repeat;
    }
</style>
